/* ============================================================
   MAISON CANDELIA — theme.js
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  // --- Header scroll shadow ---
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 30);
    });
  }

  // --- Menu mobile ---
  const hamburger = document.querySelector('.hamburger');
  const mobileMenu = document.querySelector('.mobile-menu');
  const mobileClose = document.querySelector('.mobile-menu__close');

  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', () => {
      mobileMenu.classList.add('open');
      hamburger.setAttribute('aria-expanded', 'true');
    });
  }
  if (mobileClose && mobileMenu) {
    mobileClose.addEventListener('click', () => {
      mobileMenu.classList.remove('open');
      hamburger.setAttribute('aria-expanded', 'false');
    });
  }

  // --- Galerie produit (thumbnails) ---
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  // --- Filtres collection (buttons uniquement, pas les <a> de navigation) ---
  const filterChips = document.querySelectorAll('.filter-chip:not(a)');
  filterChips.forEach(chip => {
    chip.addEventListener('click', () => {
      const group = chip.dataset.group;
      if (group) return; // géré par gift-filter.js
      filterChips.forEach(c => c.classList.remove('active'));
      chip.classList.add('active');
    });
  });

  // --- Filtres cadeaux (budget + occasion) ---
  const giftFilters = document.querySelectorAll('.gift-filter-chip');
  giftFilters.forEach(chip => {
    chip.addEventListener('click', () => {
      const group = chip.dataset.group;
      document.querySelectorAll(`.gift-filter-chip[data-group="${group}"]`)
        .forEach(c => c.classList.remove('active'));
      chip.classList.add('active');
    });
  });

  // --- Animation d'entrée au scroll ---
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });

  document.querySelectorAll('.animate-on-scroll').forEach(el => observer.observe(el));

});
